<a class="vendor" mat-stroked-button [routerLink]="['/vendors', vendor()?.vendorNumber]">
  <ideal-product-vendor-logo [productId]="productId()" />
  <span class="label">View the {{ vendor()?.name }} shop</span>
</a>
